'use strict';

module.exports = {
    CREATED: 'job.created',
    DELETED: 'job.deleted',
    PAUSED: 'job.paused',
    STOPPED: 'job.stopped',
    RESUMED: 'job.resumed',
    MODIFIED: 'job.modified'
};